import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Retreats } from './pages/Retreats';
import { Contact } from './pages/Contact';
import { Booking } from './pages/Booking';
import { LanguageProvider } from './components/LanguageContext';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <LanguageProvider data-id="element-0">
      <Router data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="min-h-screen bg-dark text-cream flex flex-col" data-id="element-3">
          <Navigation data-id="element-4" />
          <main className="flex-grow" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
              <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
              <Route path="/retreats" element={<Retreats data-id="element-12" />} data-id="element-11" />
              <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
              <Route path="/booking" element={<Booking data-id="element-16" />} data-id="element-15" />
            </Routes>
          </main>
        </div>
      </Router>
    </LanguageProvider>;
}